<script setup>
import { ref, onMounted, watch } from 'vue';
import { translate } from "../assets/translations.js";
import { useRoute } from 'vue-router';

const route = useRoute();

const text = ref('');
const toRotateEs = ["Desarrollo Web", "Desarrollo de Aplicaciones"];
const toRotateEn = ["Web Development", "App Development"];
const period = 2000;
let i = 0;
let isDeleting = false;
let delta = 300;

const languageSelected = ref(localStorage.getItem("lang") || "es");
const toRotate = ref(languageSelected.value === "es" ? toRotateEs : toRotateEn);

const tick = () => {
  const fullText = toRotate.value[i];
  if (isDeleting) {
    text.value = fullText.substring(0, text.value.length - 1);
  } else {
    text.value = fullText.substring(0, text.value.length + 1);
  }

  if (!isDeleting && text.value === fullText) {
    isDeleting = true;
    delta = 1000;
  } else if (isDeleting && text.value === '') {
    isDeleting = false;
    i = (i + 1) % toRotate.value.length;
    delta = 2000;
  }
};

onMounted(() => {
  let ticker = setInterval(() => {
    tick();
  }, delta);

  return () => clearInterval(ticker);
});

watch(() => languageSelected.value, (newLang) => {
  toRotate.value = newLang === "es" ? toRotateEs : toRotateEn;
  i = 0;
  text.value = '';
  isDeleting = false;
  delta = 300;
});

</script>

<template>
  <section class="hero-section">
    <div class="hero-container">
      <div class="hero-content">
        <h1 class="hero-title">
          {{ translate("hero").titulo }}
          <br>
          <span class="hero-typed">{{ text }}</span>
        </h1>
        <p class="hero-subtitle">
          {{ translate("hero").subtitulo }}
        </p>
        <a href="#contact" class="hero-button" aria-label="Contacto">
          {{ translate("hero").cta }}
        </a>
      </div>

      <div class="hero-image">
        <img src="/img/resicorp-black.webp" alt="Resi Corporation Logo" title="Resi Corporation Logo" />
      </div>
    </div>
  </section>
</template>


<style scoped>
.txt-rotate > .wrap {
  border-right: 0.08em solid #666;
}

.home__perfil img {
  z-index: 0;
  animation: updown 3s linear infinite;
}

@keyframes updown {
  0% {
    transform: translateY(-20px);
  }
  25%{
    transform: translateX(-20px);
  }
  50% {
    transform: translateY(20px);
  }
  75% {
    transform: translateX(20px);
  }
  100% {
    transform: translateY(-20px);
  }
}
</style>
